import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://www.uptodateconnect.com/api/v1",
});

export default axiosInstance;
